import { render, staticRenderFns } from "./JamSurveyClient.vue?vue&type=template&id=4c90f960&scoped=true"
import script from "./JamSurveyClient.vue?vue&type=script&lang=js"
export * from "./JamSurveyClient.vue?vue&type=script&lang=js"
import style0 from "./JamSurveyClient.vue?vue&type=style&index=0&id=4c90f960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c90f960",
  null
  
)

export default component.exports